import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

export const useLanguageReload = () => {
  const currentLang = useSelector((state: RootState) => state.user.lang);

  useEffect(() => {
    // Force reload all components when language changes
    window.dispatchEvent(new Event('languageChange'));
  }, [currentLang]);

  return currentLang;
};
